import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useKanban } from 'react-kanban';
import { getApi } from '../../Redux/sagas/api';
import { apiKeySelector } from '../../Redux/auth/selectors';
import { CARE_NEED_CARD } from '../api/entities';

/**
 * Reloads a single Einsatz-Dashboard care need card instead of the whole
 * board (CareNeedDashboardRefreshFilter) - one request for one care need.
 *
 * The card comes back with its current `status` (required/request/decision),
 * so kanban.insertItem() runs it through every CARE_NEED_CARD list's
 * criteria: it lands in the matching column and is removed from the others.
 * status null means the care need is in none of these columns anymore.
 */
const useRefreshCareNeedCard = () => {
    const kanban = useKanban();
    const token = useSelector(apiKeySelector);

    return useCallback(
        (careNeedId) =>
            getApi(token, `/careneed/${careNeedId}/card`).then((card) => {
                if (card && card.status) {
                    kanban.insertItem(CARE_NEED_CARD, card);
                } else {
                    kanban.deleteItem(CARE_NEED_CARD, { id: careNeedId });
                }
                return card;
            }),
        [kanban, token]
    );
};

export default useRefreshCareNeedCard;
